export enum CourseInstance {
  Course = 1,
  Instances = 2
}

export enum CourseInstanceSection {
  MainCourseInstanceSectionId = 1,
  ContentsAndSubjectsSectionId = 2,
  KeyUrlsSectionId = 3,
  DisplayFlagsSectionId = 4,
  LegacySectionId = 5,
  LegacySubjectSectionId = 6,
  StudyBC = 8
}

export enum CourseListingFilterData {
  CourseNameFieldId = 'courseName',
  CourseTypeFieldId = 'courseTypeId',
  StudyLevelFieldId = 'studyLevelId',
  QualificationFieldId = 'qualificationTypeId',
  CourseCodeFieldId = 'courseCode',
  CourseCodeTypeFieldId = 'courseCodeTypeId',
  StatusFieldId = 'status',
  CourseNameRefName = 'CourseName',
  CourseCodeRefName = 'CourseCode',
  CourseTypeRefName = 'CourseType',
  CourseCodeTypeRefName = 'CourseCodeType',
  StudyLevelRefName = 'StudyLevel',
  QualificationTypeRefName = 'QualificationType',
  StatusRefName = 'Status',
  CourseIdFieldId = 'courseId',
  ApplicableToFastlane = 'applicableForFastlane'
}

export enum CourseInstanceListingDetails {
  CourseInstanceTitleFieldId = 'courseInstanceTitle',
  CourseTypeIdFieldId = 'courseTypeId',
  AcademicYearFieldId = 'academicYear',
  StatusFieldId = 'status',
  CourseTypeRefId = 'CourseType',
  AcademicYearRefId = 'AcademicYear',
  StatusRefId = 'Status',
  CourseInstanceTitleRefName = 'CourseInstanceTitle',
  EFLParentCourseTypeId = 2,
  TypicalDurationFieldId = 'typicalDuration',
  TypicalDurationRefName = 'TypicalDuration',
  InstanceIdFieldId = 'courseInstanceId',
  idpCNCourseId ='idpCNCourseId',
  idpcLegacyCourseId = 'idpcLegacyCourseId',
  Available = 'available',
  QualificationTypeId = 'qualificationTypeId',
  QualificationType = 'QualificationType',
  CourseTitle = 'courseTitle',
  UCASCode = 'ucasCode',
  CourseCodeFieldId = 'courseCode',
  ApplicableToFastlane = 'applicableForFastlane'
}

export enum CourseType {
  GeneralCourseTypeId = '1',
  EFLCourseTypeId = '2'
}

export enum GeneralCourseInstanceSection {
  MainCourseInstanceSectionId = 1,
  ContentsAndSubjectsSectionId = 2,
  EntryRequirementsSectionId = 3,
  KeyUrlsSectionId = 4,
  DisplayFlagsSectionId = 5,
  LegacySectionId = 6,
  LegacySubjectSectionId = 7,
  StudyBC = 8
}

export enum CourseSectionDetails {
  CourseDetails = 1,
  LegacyFields = 2
}
